import { useSearchParams } from 'react-router-dom'

export const useContinueUrl = () => {
  const [search] = useSearchParams()

  return search.get('continue_url') ?? search.get('redirect_url') ?? '/'
}
